import {Component, ElementRef, Inject, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import moment from 'moment';
import Base = moment.unitOfTime.Base;
import {forkJoin, Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {BeachesService} from '../beaches.service';
import {DisplayPipe} from '../../../../../shared/src/lib/pipes/display.pipe';
import {Response} from '../../../../../shared/src/lib/services/base.service';
import {FormsModule} from '@angular/forms';
import {NgForOf, NgIf} from '@angular/common';
import {NgbCollapseModule} from '@ng-bootstrap/ng-bootstrap';

declare var $: any;

@Component({
    selector: 'app-beach-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    providers: [DisplayPipe],
    imports: [
        FormsModule,
        NgIf,
        NgbCollapseModule,
        NgForOf
    ]
})

export class BeachDashboardComponent implements OnInit {

  meta = {
    fields: {
      start: {
        type: 'datetime',
        required: false
      },
      end: {
        type: 'datetime',
        required: false
      }
    }
  };
  // public end_date = new Date(moment().format());
  // public start_date = new Date(moment().subtract(3, 'Q').format());
  public loading_activity_counts = false;
  public loading_advisory_counts = false;
  public loading_advisory_counts_by_station = false;
  public loading_results = false;
  public loading_legend = true;
  private sortOrder;
  public beaches: Response<any>;
  public monitoring_locations_reduced;
  public beaches_reduced: any;
  public loading_submissions: any;
  // private monitoringActivityService: BaseService;
  // private monitoringLocationService: BaseService;
  // private beachService: BaseService;
  // private beachAdvisoryActivityService: BaseService;
  // private beachResultService: BaseService;
  // private beachAdvisoryAggregateService: BaseService;
  // private beachesService.submissionsService: BaseService;
  public date_ranges: any;
  // todo: define types so this will build
  private monitoringLocations: Response<any>;
  public loading_beach_advisories: boolean;
  // private beaches: Response<any>;
  public ResultIsCollapsed = true;
  public AdvisoryIsCollapsed = true;
  public SamplingIsCollapsed = true;
  public DateIsCollapsed = false;
  public ed_date;
  public end_date;
  public start_date;


  constructor(http: HttpClient, public displayPipe: DisplayPipe, public beachService: BeachesService) {
    // this.monitoringActivityService = new BaseService(`${environment.baseUrl}/water_sampling/monitoringactivity`, http);
    // this.monitoringLocationService = new BaseService(`${environment.baseUrl}/water_sampling/monitoringlocation`, http);
    // this.beachService = new BaseService(`${environment.baseUrl}/beaches/beach/`, http);
    // this.beachAdvisoryActivityService = new BaseService(`${environment.baseUrl}/beaches/advisoryactivity/`, http);
    // this.beachResultService = new BaseService(`${environment.baseUrl}/water_sampling/result`, http);
    // this.beachAdvisoryAggregateService = new BaseService(`${environment.baseUrl}/beaches/beachadvisoryaggregate/`, http);
    // this.beachesService.submissionsService = new BaseService(`${environment.baseUrl}/beaches/submission/`, http);
  }


  ngOnInit() {
    // this.end_date = new Date(moment().format('YYYY-DD-MM'));
    this.end_date = moment().format('YYYY-MM-DD');
    this.start_date = moment().subtract(3, 'Q').startOf('quarter').format('YYYY-MM-DD');
  }

  private convertObject(item, meta, dateStart) {
    const newItem: any = {};
    Object.keys(item).forEach((key) => {
      newItem[meta.fields[key].label] = this.displayPipe.transform(item[key], meta.fields[key].choices);
    });
    if (item.hasOwnProperty('monitoring_location')) {
      newItem['Monitoring Location'] = this.monitoring_locations_reduced[item.monitoring_location];
    } else if (item.hasOwnProperty('beach')) {
      newItem.Beach = this.beaches_reduced[item.beach];
    }
    newItem.Quarter = this.get_quarter_label(dateStart);
    return newItem;
  }

  private getSampleActivityCounts() {
    this.loading_activity_counts = true;
    let results: any[] = [];
    const promises: any[] = [];
    this.date_ranges.forEach((dateRange, i) => {
      promises.push(this.beachService.monitoringActivityService.getList({
        sample_collection_datetime_gt: dateRange.start.toISOString(),
        sample_collection_datetime_lt: dateRange.end.toISOString(),
        page_size: 'max'
      }).pipe(tap(response => {
        results = results.concat(response.results.map((item) => {
          return this.convertObject(item, response.meta, dateRange.start);
        }));
      })));
    });
    forkJoin(promises).subscribe(() => {
      this.renderPivot(results, '#sampling_activity_table', ['Monitoring Location'], ['Quarter']);
      this.renderPivotUI(results, '#sampling_table');
      this.loading_activity_counts = false;
    });
  }

  private getAdvisoryActivityCounts() {
    this.loading_advisory_counts = true;
    let results: any[] = [];
    const promises: any[] = [];
    this.date_ranges.forEach((date_range, i) => {
      promises.push(this.beachService.advisoryService.getList({
        actual_startdate_gt: date_range.start.toISOString(),
        actual_startdate_lt: date_range.end.toISOString(),
        page_size: 'max'
      }).pipe(tap(response => {
        results = results.concat(response.results.map((item) => {
          return this.convertObject(item, response.meta, date_range.start);
        }));
      })));
    });
    forkJoin(promises).subscribe(() => {
      this.renderPivot(results, '#sampling_activity_table', ['Monitoring Location'], ['Quarter']);
      this.loading_advisory_counts = false;
    });
  };

// private getAdvisoryTypeCodes() {
//   this.beachAdvisoryActivityService.get('metadata').pipe(tap(() => {
//     this.advisory_type_codes = response.fields.type_code.choices;
//   });
// }

  private renderPivot(data, div, rows, cols, derivedAttributes ?, sumField ?) {
    $(() => {
      // const derivers = $.pivotUtilities.derivers;
      const options: any = {
        derivedAttributes: derivedAttributes ? derivedAttributes : {},
        rows,
        cols,
        sorters: {
          Quarter: $.pivotUtilities.sortAs(
            this.sortOrder
          )
        }
      };

      if (sumField !== undefined) {
        const sum = $.pivotUtilities.aggregatorTemplates.sum;
        const numberFormat = $.pivotUtilities.numberFormat;
        const intFormat = numberFormat({digitsAfterDecimal: 0});
        options.aggregator = sum(intFormat)([sumField]);
      }

      $(div).pivot(data, options);
    });
  }

  private renderPivotUI(data, div, derivedAttributes ?) {
    $(() => {
      $(div).pivotUI(data, {
        derivedAttributes: derivedAttributes ? derivedAttributes : {},
        renderers: $.extend(
          $.pivotUtilities.renderers,
          $.pivotUtilities.plotly_renderers
        )
      });
    });
  }

  private getAdvisoryByStation() {
    let results: any[] = [];
    const promises: any[] = [];
    this.date_ranges.forEach((dateRange, i) => {
      promises.push(this.beachService.advisoryService.getList({
        page_size: 'max',
        actual_startdate_gt: dateRange.start.toISOString(),
        actual_startdate_lt: dateRange.end.toISOString()
      }).pipe(tap((response) => {
        results = results.concat(response.results.map((item) => {
          return this.convertObject(item, response.meta, dateRange.start);
        }));
      })));
    });
    forkJoin(promises).subscribe(() => {
      this.renderPivot(results, '#advisory_by_station_table', ['Monitoring Location', 'Type'], ['Quarter']);
      this.renderPivot(results, '#advisory_activity_type_table', ['Type'], ['Quarter']);
      this.renderPivotUI(results, '#advisory_table');
      this.loading_advisory_counts_by_station = false;
    });
  }

  public get_quarter_label(date) {
    if (date.quarter() === 4) {
      return 'Q1FY' + (parseInt(date.format('YY'), 10) + 1);
    } else {
      const tempQuarter = date.quarter() + 1;
      return 'Q' + tempQuarter + 'FY' + date.format('YY');
    }
  }

  private getResults() {
    this.loading_results = true;
    let results: any[] = [];
    const promises: any[] = [];
    this.date_ranges.forEach((date_range, i) => {
      promises.push(this.beachService.resultsService.getList({
        page_size: 'max',
        sample_collection_datetime_gt: date_range.start.toISOString(),
        sample_collection_datetime_lt: date_range.end.toISOString()
      }).pipe(tap(response => {
        results = results.concat(response.results.map((item) => {
          return this.convertObject(item, response.meta, date_range.start);
        }));
      })));
    });
    forkJoin(promises).subscribe(() => {
      this.renderPivotUI(results, '#result_table');
      this.loading_results = false;
    });
  }

  private getBeachAdvisories() {
    this.loading_beach_advisories = true;
    let results: any[] = [];
    const promises: any[] = [];
    this.date_ranges.forEach((date_range, i) => {
      promises.push(this.beachService.advisoryAggregateService.getList({
        page_size: 'max',
        actual_startdate_gt: date_range.start.toISOString(),
        actual_startdate_lt: date_range.end.toISOString()
      }).pipe(tap(response => {
        results = results.concat(response.results.map((item) => {
          return this.convertObject(item, response.meta, date_range.start);
        }));
      })));
    });

    forkJoin(promises).subscribe(() => {
      this.renderPivot(results, '#advisories_by_beach_table', ['Beach', 'Type'], ['Quarter']);
      this.loading_beach_advisories = false;
    });
  }

  private getSubmissions() {
    this.loading_submissions = true;
    let results: any[] = [];
    const promises: any[] = [];
    this.date_ranges.forEach((date_range, i) => {
      promises.push(this.beachService.submissionsService.getList({
        page_size: 'max',
        date_gt: date_range.start.toISOString(),
        date_lt: date_range.end.toISOString()
      }).pipe(tap(response => {
        results = results.concat(response.results.map((item) => {
          return this.convertObject(item, response.meta, date_range.start);
        }));
      })));
    });

    forkJoin(promises).subscribe(() => {
      this.renderPivot(results, '#submissions_table', ['Content'], ['Quarter']);
      this.renderPivot(results, '#submissions_activities_table', ['Content'], ['Quarter'], {
        "Total Activities": function (record) {
          if (record.Content === "Monitoring") {
            return record["Monitoring activities"].length;
          } else if (record.Content === "Notification") {
            return record["Advisory activities"].length;
          }
        }
      }, "Total Activities");
      this.loading_submissions = false;
    });
  }

  public sumTypeTotals(counts, location) {
    let total = 0;
    this.date_ranges.forEach(function (value, i) {
      if (counts[i] !== undefined && counts[i].hasOwnProperty(location)) {
        total += counts[i][location].total;
      }
    });
    return total;
  }

//
  public sumQuarterTotals(counts, quarter) {
    let total = 0;
    Object.keys(counts[quarter]).forEach(type_code => {
      total += counts[quarter][type_code].total;
    });
    return total;
  }

//
  public sumAllTotals(counts) {
    let total = 0;
    this.date_ranges.forEach(function (value, i) {
      Object.keys(counts[i]).forEach(function (type_code) {
        total += counts[i][type_code].total;
      });
    });
    return total;
  }


  private getQuarterRange(quarter) {
    const start = moment(this.end_date).quarter(quarter).startOf('quarter');
    const end = moment(this.end_date).quarter(quarter).endOf('quarter');
    return {start, end};
  }

//


  public setRanges() {
    let currentQuarter = moment(this.end_date).quarter();
    const lastQuarter = this.getQuarterRange(currentQuarter);
    lastQuarter.end = moment(this.end_date);
    this.date_ranges = [lastQuarter];
    while (moment(this.start_date) < this.date_ranges[0].start) {
      currentQuarter--;
      this.date_ranges.unshift(this.getQuarterRange(currentQuarter));
    }
    this.date_ranges[0].start = moment(this.start_date);
  }


  private setSortOrder() {
    this.sortOrder = this.date_ranges.map((range) => {
      return this.get_quarter_label(range.end);
    });
  }

  public updateRanges() {
    this.loading_legend = false;
    this.setRanges();
    this.setSortOrder();
    this.beachService.getList<any>({page_size: 'max'}).subscribe((response) => {
      this.monitoringLocations = response;
      this.monitoring_locations_reduced = response.results.reduce((a, item) => {
        a[item.globalid] = item.name;
        return a;
      }, {});
      this.getSampleActivityCounts();
      this.getAdvisoryByStation();
      this.getResults();
    });


    this.loading_beach_advisories = true;
    this.beachService.beachService.getList<any>({page_size: 'max'}).subscribe((response) => {
      this.beaches = response;
      this.beaches_reduced = response.results.reduce((a, item) => {
        a[item.globalid] = item.name;
        return a;
      }, {});
      this.getBeachAdvisories();
    });

    this.getSubmissions();
  }
}
